export const APP_FORM_SECTIONS = {
  GENERAL: "General Information",
  ANDROID: "Android App Information",
  IOS: "iOS App Information",
};

export const APP_FORM_FIELDS = {
  GENERAL: [
    { name: "Project", label: "Project", required: true },
    { name: "station_name", label: "Station Name", required: true },
    { name: "app_name", label: "App Name", required: true },
    { name: "alias", label: "Alias", required: true },
  ],
  ANDROID: [
    { name: "android_bundle", label: "Bundle ID", required: true },
    { name: "bucket_url", label: "Bucket URL", required: false },
  ],
  IOS: [
    { name: "vendor_id", label: "Vendor ID", required: false },
    {
      name: "p8_file",
      label: "P8 File Data",
      required: false,
      type: "textarea",
    },
    { name: "key_id", label: "Key ID", required: false },
    { name: "issuer_id", label: "Issuer ID", required: false },
    {
      name: "sku",
      label: "SKU",
      required: true,
      type: "text",
    },
  ],
};

export const APP_TABLE_HEADERS = [
  "S. No.",
  "Station Name",
  "App Name",
  "Alias",
  "Project",
  "SKU",
  "Action",
];

export const APP_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
};

export const APP_STATUS_LABELS = {
  [APP_STATUS.ACTIVE]: "Active",
  [APP_STATUS.INACTIVE]: "Inactive",
  [APP_STATUS.PENDING]: "Pending",
};

export const APP_STATUS_COLORS = {
  [APP_STATUS.ACTIVE]: "success",
  [APP_STATUS.INACTIVE]: "secondary",
  [APP_STATUS.PENDING]: "warning",
};
